var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEthereumcoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_106668",
    "data-name": "Group 106668",
    transform: "translate(3841.5 3757.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49323",
    "data-name": "Path 49323",
    d: "M22,0A22,22,0,1,1,0,22,22,22,0,0,1,22,0Z",
    transform: "translate(-3841 -3757)",
    fill: "#f3f4f8",
    stroke: "#c9cbd2",
    strokeWidth: 1,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1",
    transform: "translate(-3827 -3749)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_1421394342400"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_106029",
    "data-name": "Group 106029"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49317",
    "data-name": "Path 49317",
    d: "M383.682,0,383.5.619V18.567l.182.182,8.331-4.925Z",
    transform: "translate(-375.35)",
    fill: "#343434"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49318",
    "data-name": "Path 49318",
    d: "M8.332,0,0,13.824l8.332,4.925V0Z",
    fill: "#8c8c8c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49319",
    "data-name": "Path 49319",
    d: "M387.343,729.812l-.1.125v6.394l.1.3,8.337-11.741Z",
    transform: "translate(-379.011 -709.486)",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49320",
    "data-name": "Path 49320",
    d: "M8.332,736.631v-6.819L0,724.89Z",
    transform: "translate(0 -709.486)",
    fill: "#8c8c8c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49321",
    "data-name": "Path 49321",
    d: "M392.07,481.042l8.331-4.925-8.331-3.787Z",
    transform: "translate(-383.738 -462.293)",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49322",
    "data-name": "Path 49322",
    d: "M0,476.117l8.332,4.925V472.33Z",
    transform: "translate(0 -462.293)",
    fill: "#393939"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthereumcoin);
export default __webpack_public_path__ + "static/media/ethereumcoin.f0f11c0c6944906fbd8483a8665265c3.svg";
export { ForwardRef as ReactComponent };